import { ProcessDiagram, type ProcessStep } from '@/components/help/ProcessDiagram';

// State-diagram wrappers for the Tier 3 lifecycle reference articles. Each is a
// thin wrapper around <ProcessDiagram> with a hard-coded steps array. The
// underlying primitive renders the complete diagram (every node highlighted)
// when the viewer prefers reduced motion, so these honour that preference for
// free. Branching transitions (reviewing -> revising or draft, brief ->
// published / rejected / archived, live <-> unpublished) are documented in the
// article prose rather than drawn as separate arrows; the diagram shows the
// states themselves in their primary progression order.

const PIPELINE_STATES: ProcessStep[] = [
  { label: 'pending', icon: 'IconClock' },
  { label: 'writing', icon: 'IconPencil' },
  { label: 'reviewing', icon: 'IconChecklist' },
  { label: 'revising', icon: 'IconRefresh' },
  { label: 'draft', icon: 'IconFileText' },
  { label: 'failed', icon: 'IconAlertTriangle' },
  { label: 'cancelled', icon: 'IconX' },
];

const ARTICLE_LIFECYCLE: ProcessStep[] = [
  { label: 'draft', icon: 'IconFileText' },
  { label: 'publishing', icon: 'IconRefresh' },
  { label: 'live', icon: 'IconWorld' },
  { label: 'archived', icon: 'IconBox' },
  { label: 'hard deleted', icon: 'IconTrash' },
];

const BRIEF_LIFECYCLE: ProcessStep[] = [
  { label: 'proposed', icon: 'IconBulb' },
  { label: 'approved', icon: 'IconCheck' },
  { label: 'in_pipeline', icon: 'IconRoute' },
  { label: 'published', icon: 'IconWorld' },
  { label: 'rejected', icon: 'IconX' },
  { label: 'archived', icon: 'IconBox' },
];

const ANNOTATION_LIFECYCLE: ProcessStep[] = [
  { label: 'created', icon: 'IconPencil' },
  { label: 'submitted', icon: 'IconArrowRight' },
  { label: 'resolved', icon: 'IconCheck' },
  { label: 'cleared', icon: 'IconTrash' },
];

export function PipelineStatesDiagram(): JSX.Element {
  return <ProcessDiagram steps={PIPELINE_STATES} />;
}

export function ArticleLifecycleDiagram(): JSX.Element {
  return <ProcessDiagram steps={ARTICLE_LIFECYCLE} />;
}

export function BriefLifecycleDiagram(): JSX.Element {
  return <ProcessDiagram steps={BRIEF_LIFECYCLE} />;
}

export function AnnotationLifecycleDiagram(): JSX.Element {
  return <ProcessDiagram steps={ANNOTATION_LIFECYCLE} />;
}
